import { MessageGroup } from '../types';

/**
 * Group multiple messages in the same array
 * This can be useful to group multiple messages from the same user together
 * or two messages of the same topic
 */
export const groupChatMessagesTogether = <Message extends { id: string | number }>(
    /** The messages to sort by group */
    messages: Message[],
    /**
     * Callback called to decide whether a message should be grouped with the previous message or not.
     * Returning true will add the current message to the group of the previous message
     * Returning false will create a new group
     */
    groupWithPreviousMessageSelector: (message: Message, previousMessage: Message) => boolean,
) =>
    messages.reduce<Array<MessageGroup<Message>>>((acc, curr, index, originalArray) => {
        const previousMessage = index === 0 ? undefined : originalArray[index - 1];

        if (previousMessage && groupWithPreviousMessageSelector(curr, previousMessage) && acc.length > 0) {
            acc[acc.length - 1].messages.push(curr);
            return acc;
        }

        return [
            ...acc,
            {
                id: `group-${curr.id}`,
                messages: [curr],
            },
        ];
    }, []);
